import { render, staticRenderFns } from "./tickets-list.vue?vue&type=template&id=be61a346&scoped=true"
import script from "./tickets-list.vue?vue&type=script&lang=js"
export * from "./tickets-list.vue?vue&type=script&lang=js"
import style0 from "./tickets-list.vue?vue&type=style&index=0&id=be61a346&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be61a346",
  null
  
)

export default component.exports